import { MODAL_ACTION_TYPES } from '@spa/shared/store/actions/modal';

const initialState = {
  modals: []
};

const modalReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MODAL_ACTION_TYPES.MODAL_SHOW:
      return {
        ...state,
        modals: state.modals.some(modal => modal.modalId === payload.modalId)
          ? state.modals.map(modal => (modal.modalId === payload.modalId ? { ...modal, ...payload } : modal))
          : [...state.modals, payload]
      };
    case MODAL_ACTION_TYPES.MODAL_HIDE:
      return {
        ...state,
        modals: payload.modalId ? state.modals.filter(modal => modal.modalId !== payload.modalId) : []
      };
    default:
      return state;
  }
};

export default modalReducer;
